<template>
    <div>
      <div class="table-responsive">
        <v-skeleton-loader
            type="table-thead"
            v-if="studentLoading"
        >
        </v-skeleton-loader>

        <v-skeleton-loader
            v-if="studentLoading"
            type="table-row-divider@25"
        >
        </v-skeleton-loader>
        <table class="table" v-if="!studentLoading">
          <thead>
            <tr class="px-3">
              <th class="px-3">Image</th>
              <th class="px-3">Name</th>
              <th class="px-3">CRN</th>
              <th class="px-3">Enrolled courses</th>
              <th class="px-3">Status</th>
            </tr>
          </thead>
          <tbody>
            <tr v-show="assigned_students.length > 0" v-for="(item,index) in assigned_students" :key="index">
              <td class="px-3">
                <div class="symbol-label">
                  <img v-if="item.image_path && item.image_path.real"
                       :src="item.image_path.real"
                       class="cursor-pointer" alt=""
                       @click="changeImage(item)"
                       style="height: 30px;">
                  <span v-else class="symbol symbol-35 symbol-light-success">
                    <span class="symbol-label font-size-sm font-weight-bold cursor-pointer"
                    >{{ item.first_name ? item.first_name.charAt(0).toUpperCase() : '' }}{{ item.last_name ? item.last_name.charAt(0).toUpperCase() : '' }}</span>
                  </span>
                </div>
              </td>
              <td class="px-3">
                <span class="font-weight-medium">
                  {{ item.full_name }}
                </span>
              </td>
              <td class="px-3">
                <span class="font-weight-medium">
                   {{ item.personal_id ? item.personal_id : "N/A" }}
                </span>
              </td>
              <td class="px-3">
                <div class="text-secondary">
                  <span class="font-weight-black">Program :</span> {{ item.setting.program_title ? item.setting.program_title : "N/A" }}
                </div>
                <div class="text-secondary">
                  <span class="font-weight-black"> Semester/Year :</span> {{ item.setting && item.setting.current_semester_title ? item.setting.current_semester_title : "N/A" }}
                </div>
                <div class="text-secondary">
                  <span class="font-weight-black">Class :</span> {{ item.setting.current_class_title ? item.setting.current_class_title : "N/A" }}
                </div>
              </td>
              <td class="px-3 ">
                <div class="mt-2">
                          <span class="badge badge-success text-lg "
                                v-bind:class="{ 'badge-success': item.is_active, 'badge-danger': !item.is_active }">
                            {{ item.is_active ? 'Active' : 'Inactive' }}
                          </span>
                </div>
              </td>
            </tr>
            <tr v-if="assigned_students.length == 0">
              <td class="text-center" colspan="5">
                <strong>No items found.</strong>
              </td>
            </tr>
          </tbody>
        </table>
        <b-pagination
            v-if="assigned_students.length > 0"
            class="pull-right mt-7"
            @input="getAssignedStudents"
            v-model="page"
            :total-rows="total"
            :per-page="perPage"
            first-number
            :studentLoading="studentLoading"
            last-number
        ></b-pagination>
      </div>
<!--        <v-data-table
                :studentLoading="isLoading"
                :headers="headers"
                :items-per-page="20"
                :items="assigned_students"
        >
            <template v-slot:item.thumbnail="{ item }">
                <div class="symbol-label">
                  <img v-if="item.image_path && item.image_path.real"
                       :src="item.image_path.real"
                       class="cursor-pointer" alt=""
                       @click="changeImage(item)"
                       style="height: 30px;">
                  <span v-else class="symbol symbol-35 symbol-light-success">
                    <span class="symbol-label font-size-sm font-weight-bold cursor-pointer"
                    >{{ item.first_name ? item.first_name.charAt(0).toUpperCase() : '' }}{{ item.last_name ? item.last_name.charAt(0).toUpperCase() : '' }}</span>
                  </span>
                </div>
            </template>
            <template v-slot:item.full_name="{ item }">
                {{ item.full_name }}
            </template>
            <template v-slot:item.personal_id="{ item }">
             {{ item.personal_id ? item.personal_id : "N/A" }}
            </template>
            <template v-slot:item.is_active="{ item }">
              <span :class="item.is_active?'badge badge-success':'badge badge-danger'">{{item.is_active ? 'Active' : 'Inactive' }}</span>
            </template>
        </v-data-table>-->
    </div>
</template>

<script>
import AcademicClassService from "@/core/services/academic-class/AcademicClassService";
const academicClassService = new AcademicClassService();
export default {
        name: "class-summary-students",
        props:['class_id'],
        data() {
            return {
              assigned_students:[],
              studentLoading:false,
              page:null,
              total:null,
              perPage:null,
            }
        },
      methods:{
        getAssignedStudents() {
          this.studentLoading=true;
          academicClassService
              .getAssignedStudents(this.class_id,this.page)
              .then(response => {
                  this.assigned_students = response.data.data;
                  this.page = response.data.meta.current_page;
                  this.total = response.data.meta.total;
                  this.perPage = response.data.meta.per_page;

                  this.$emit('count_assigned_students',response.data.meta.total);
              })
              .catch((err) => {

              })
              .finally(() => {
                this.studentLoading = false;
              });
        },

      },
  mounted() {
    this.getAssignedStudents();
  }

}
</script>

<style scoped>

</style>
